import { AppStateType } from ".";
import { City } from "../config/googleForm.config";

const AppState: AppStateType = {
  contactFormDetails: {
    name: "",
    email: "",
    message: "",
  },
  selectedCity: null,
  enabledCities: process.env.REACT_APP_AVAILABLE_CITIES
    ? (process.env.REACT_APP_AVAILABLE_CITIES.split(",") as City[])
    : [],
};

export { AppState };
